import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { pathwayFlow, pathwaySteps } from '../../data/content';
export function Pathway() {
  return <section className="bg-canvas px-5 py-14 md:py-20" data-id="element-253" data-mp="4d3xzuz9wxk5">
      <div className="mx-auto max-w-5xl" data-id="element-254" data-mp="9boqt9c74eyk">
        <SectionHeading eyebrow="Introducing the Post-Op Wound Assessment Pathway™" title="One Structured System. Five Practical Steps." subtitle="A repeatable framework designed to help qualified healthcare professionals organize postoperative wound assessments and communication." data-id="element-255" data-mp="9djcipvakb3p" />

        <ol className="relative mx-auto mt-10 max-w-2xl" data-id="element-256" data-mp="3mqbn5n9adtiy">
          {pathwaySteps.map((step, i) => <li key={step.title} className="relative flex gap-4 pb-6 last:pb-0" data-id="element-257" data-mp="x19mmstg76p9" data-mpi={i}>
              {i < pathwaySteps.length - 1 && <span className="absolute left-[23px] top-12 h-[calc(100%-3rem)] w-0.5 bg-teal/25" aria-hidden="true" data-id="element-258" data-mp="11z1drkm9qose" />}
              <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-teal text-lg font-extrabold text-white" data-id="element-259" data-mp="1c4pxe1fjpqed">
                {i + 1}
              </span>
              <div className="flex-1 rounded-2xl bg-white p-5 shadow-sm ring-1 ring-navy/5" data-id="element-260" data-mp="13300ig2w9z97">
                <p className="text-xs font-extrabold uppercase tracking-wider text-teal" data-id="element-261" data-mp="y5hzdbv4cobr">Step {i + 1}</p>
                <h3 className="mt-1 text-lg font-extrabold leading-tight text-navy md:text-xl" data-id="element-262" data-mp="t8riwnfejqpt">{step.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-navy/75" data-id="element-263" data-mp="oe3s2hwxek82">{step.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 max-w-2xl rounded-2xl bg-navy p-5 text-center" data-id="element-264" data-mp="fgbaf73qf0hi">
          <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-2" data-id="element-265" data-mp="agf7zcaonh42">
            {pathwayFlow.map((f, i) => <React.Fragment key={f} data-id="element-266" data-mp="5hm3289goyfi" data-mpi={i}>
                <span className="text-sm font-extrabold uppercase tracking-wide text-gold md:text-base" data-id="element-267" data-mp="3ryujip1irdkf">{f}</span>
                {i < pathwayFlow.length - 1 && <ArrowRightIcon className="h-4 w-4 text-white/60" aria-hidden="true" data-id="element-268" data-mp="tcn9obwqs8l" />}
              </React.Fragment>)}
          </div>
          <p className="mt-4 text-sm leading-relaxed text-white/80" data-id="element-269" data-mp="3mzrntv7fijp4">
            No unnecessary theory. No disconnected reference material. Just practical tools designed around real
            postoperative monitoring responsibilities.
          </p>
        </div>

        <SectionCTA label="Access All 5 Steps" data-id="element-270" data-mp="jijanonnc80q" />
      </div>
    </section>;
}